import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeletePackageAssetType($companyId: ID!, $id: ID!) {
    deletePackageAssetType(companyId: $companyId, id: $id) {
      packageAssetType {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
